"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputContainer = exports.TextInput = exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  width: 100%;\n"], ["\n  color: ", ";\n  width: 100%;\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
});
var TextInput = styled_components_1.default.input.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isTitle'].includes(prop);
  }
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-weight: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  border: 0;\n  width: 100%;\n  outline: none;\n  font-size: ", ";\n  height: 1.5rem;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n    border: 0;\n  }\n"], ["\n  font-weight: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  border: 0;\n  width: 100%;\n  outline: none;\n  font-size: ", ";\n  height: 1.5rem;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n    border: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT_FONT_WEIGHT.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE["100"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.MEDIUM', theme);
}, function (props) {
  return props.isTitle ? '1.5rem' : '1rem';
});
exports.TextInput = TextInput;
var InputContainer = (0, styled_components_1.default)(ui_text_1.Text).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isTitle', 'readOnly', 'lineclamp'].includes(prop);
  }
})(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  display: inline-block;\n  width: 100%;\n  font-size: ", ";\n  line-height: 1.5rem;\n  ", "\n  ", "\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  display: inline-block;\n  width: 100%;\n  font-size: ", ";\n  line-height: 1.5rem;\n  ", "\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["800"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT_FONT_WEIGHT.MEDIUM', theme);
}, function (props) {
  return props.isTitle ? '1.5rem' : '1rem';
}, function (props) {
  return props.lineclamp ? (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n          overflow: hidden;\n          -webkit-line-clamp: ", ";\n          -webkit-box-orient: vertical;\n          display: -webkit-box;\n        "], ["\n          overflow: hidden;\n          -webkit-line-clamp: ", ";\n          -webkit-box-orient: vertical;\n          display: -webkit-box;\n        "])), props.lineclamp) : '';
}, function (props) {
  return props.readOnly ? '' : (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n          &:hover {\n            background-color: ", ";\n            cursor: pointer;\n            border-radius: ", ";\n          }\n        "], ["\n          &:hover {\n            background-color: ", ";\n            cursor: pointer;\n            border-radius: ", ";\n          }\n        "])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE["100"]', theme);
  }, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.MEDIUM', theme);
  });
});
exports.InputContainer = InputContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;